import React from "react";
import { P_Props } from "./BannerPublishForm.type";
import { loadCallback } from "../../../../../utils";
import { SimpleModalHeader } from "../../../../components";
import { GrabDotsIcon } from "../../../../icons";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: `${grid * 2}px 0 ${grid * 2}px 1rem`,
  margin: "0 0 14px 0",
  border: "1.2px solid #BDC6D7",
  borderRadius: "4px",
  filter: "drop-shadow(4px 4px 20px rgba(91, 91, 91, 0.5))",

  // change background colour if dragging
  background: isDragging ? "#fff" : "",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "" : "",
  height: "100%",
  padding: grid, // Tạo vùng drop để kéo qua khi cột rỗng
});

const BannerPublishFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;

  return (
    <>
      <div className="banner-publish-form">
        <SimpleModalHeader
          title="Publish Banner"
          onClose={() => {
            props.onCancel();
          }}
        />
        <div className="banner-publish-form__container">
          <DragDropContext onDragEnd={props.onDragEnd}>
            <div className="banner-publish-form__col">
              <div className="banner-publish-form__col--title">
                <h3>Published Banners</h3>
                <p>Show banner image in order</p>
              </div>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    {...provided.droppableProps}
                  >
                    {props.bannerData.active.map((item, index) => (
                      <Draggable key={item.id} draggableId={item.id} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                          >
                            <span className="banner-publish-form__col--index">{index + 1}</span>
                            <div
                              style={{
                                display: "flex",
                              }}
                            >
                              <GrabDotsIcon size={[14, 18]} color="#272B2F" />
                              <p style={{ marginLeft: "2rem", fontSize: "16px", marginBottom: 0 }}>{item.title}</p>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
            <div className="banner-publish-form__col">
              <div className="banner-publish-form__col--title">
                <h3>List of Banner images</h3>
                <p>Drag and drop from right to left which banner you want to publish on homepage slider</p>
              </div>
              <Droppable droppableId="droppable2">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                    {...provided.droppableProps}
                  >
                    {props.bannerData.inactive.map((item, index) => (
                      <Draggable key={item.id} draggableId={item.id} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <GrabDotsIcon size={[14, 18]} color="#272B2F" />
                              <p style={{ marginLeft: "2rem", fontSize: "16px", marginBottom: 0 }}>{item.title}</p>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          </DragDropContext>
        </div>

        <div className="banner-form__footer">
          <button
            className="btn cancel"
            onClick={(e) => {
              e.preventDefault();
              props.onCancel();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn save"
            onClick={(e) => {
              loadCallback(submit, e);
              props.onSubmit();
            }}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
};

export default BannerPublishFormPresenter;
